<template lang="pug">
  .answers
    Head
    Body
</template>
<script>
import Head from './layouts/Head';
import Body from './layouts/Body';
import moment from 'moment';
import replaceRouteQuery from '@/functions/replaceMultipleRouteQuery';

export default {
  components: {
    Head,
    Body
  },
  watch: {
    '$route.query': function () {
      this.$store.dispatch('msg/getTractionMsgReportsList');
    }
  },
  async mounted() {
    if (!this.$route.query.year || !this.$route.query.period) {
      const period = this.$route.query.period ? this.$route.query.period : 1;
      const year = this.$route.query.year
        ? this.$route.query.year
        : moment().year();
      const groupIds = this.$route.query.groupIds
        ? this.$route.query.groupIds
        : '';
      await replaceRouteQuery([
        {
          name: 'year',
          value: year,
          method: 'replace'
        },
        {
          name: 'period',
          value: period,
          method: 'replace'
        },
        {
          name: 'groupIds',
          value: groupIds,
          method: 'replace'
        }
      ]);
    }
    await this.$store.dispatch('msg/getTractionMsgReportsList');
  },
  destroyed() {
    this.$store.dispatch('msg/setData', { path: 'users', value: [] });
    this.$store.dispatch('msg/setData', { path: 'tariffs', value: [] });
    this.$store.dispatch('msg/setData', { path: 'streams', value: [] });
    this.$store.dispatch('msg/setData', { path: 'analitics', value: [] });
  }
};
</script>
